import * as React from "react";
import { useRegistrationContext } from "../Contexts/RegistrationContext";
import { Upload } from "../Forms/Upload";
import { UploadList } from "../Forms/UploadList";
import { Result, UploadState } from "../Map/enums";

export interface ISubmitStatus {
    name: UploadState | string;
    result: Result;
}
export interface ISummaryParams {
    customer: ISection;
    transporting: IAliasSection;
    contactPerson?: ISection;
    snapshot?: string;
    attachments?: ISection;
    date?: string;
    applicationId: string;
}

interface IAliasValue {
    alias: string;
    value: string;
}
interface ISection {
    title: string;
    rows: string[];
}
interface IAliasSection {
    title: string;
    rows: IAliasValue[];
}

export const Section = ({ classname, data }: { classname: string; data: ISection }): JSX.Element => (
    <div className={classname}>
        <div className="title">{data.title}</div>
        {data.rows.map((row) => (
            <div className="row" key={data.title + row}>
                {row}
            </div>
        ))}
    </div>
);

export const AliasSection = ({ classname, data }: { classname: string; data: IAliasSection }): JSX.Element => (
    <div className={classname}>
        <div className="title">{data.title}</div>
        {data.rows.map((row, i) =>
            row ? (
                <div className="row" key={row.alias + row.value + i}>
                    {row.alias ? <span>{row.alias}</span> : null}
                    {row.value ? <span>{row.value}</span> : null}
                </div>
            ) : null
        )}
    </div>
);
export const AttachmentSection = ({ classname, data }: { classname: string; data: ISection }): JSX.Element => {
    const { attachments, setAttachments } = useRegistrationContext();

    return (
        <div className={classname}>
            <div className="title">{data.title}</div>
            <UploadList onChange={setAttachments} fileList={attachments}></UploadList>
        </div>
    );
};

export const SnapshotSection = ({ classname, snapshot }: { classname: string; snapshot: string }): JSX.Element => {
    return (
        <div className={classname}>
            <img className="snapshot" src={snapshot}></img>
        </div>
    );
};

export const UploadSection = ({ classname, title }: { classname: string; title: string }): JSX.Element => (
    <div className={classname}>
        <div className="title">{title}</div>
        <Upload></Upload>
    </div>
);
